<template>
  <div id="wrap" v-loading="loading">
    <div class="flex flex-justify flex-wrap">
      <div>
        <el-form :inline="true">
          <el-form-item label="申报区间：">
            <el-date-picker
              v-model="value1"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-forma="yyyy-MM-dd"
              :default-time="['12:00:00']"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" @click="generate"
          ><i class="el-icon-plus"></i> 生成</el-button
        >
      </div>
    </div>

    <div class="flex flex-justify title_box">
      <div>
        <i class="el-icon-warning" style="color: #4988df"> 生成记录 </i>
      </div>
      <div>
        <!--        <el-link type="primary" style="margin-left: 20px" :underline="false"
          >删除</el-link
        >-->
      </div>
    </div>

    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ background: '#F5F7FA' }"
      stripe
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="辅助账名称" prop="fileName"></el-table-column>
      <el-table-column
        prop="name"
        :formatter="reportFormat"
        label="申报区间"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="operator"
        label="操作员"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="generateTime"
        label="生成日期"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="green"
            @click="download(scope.row.id)"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-end">
      <el-pagination
        class="pagination"
        background
        :current-page.sync="queryParam.pageNum"
        :page-size.sync="queryParam.pageSize"
        layout="prev, pager, next,total"
        :total="total"
        @current-change="search"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getProjectAccount,
  singleProjectGenerate,
  downloadAuxiliaryAccount,
} from "./project";
export default {
  data() {
    return {
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
      radio: "1",
      input1: "",
      value1: [],
      ruleForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      tableData: [
        {
          date: "1",
          name: "技术部",
          address: "初始规则",
          year: "无",
          batch: "1",
          founder: "何永浩",
          creationtime: "2020-10-11",
          completeness: "25%",
          state: "申请中",
        },
      ],
      value: "",
      options: [
        {
          value: "1",
          label: "产品一部",
          children: [
            {
              value: "2",
              label: "研发部",
              children: [
                {
                  value: "3",
                  label: "软件",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.search();
    },
    reportFormat(row, col) {
      return row.reportingIntervalBegin + "至" + row.reportingIntervalEnd;
    },
    generate() {
      if (this.value1.length == 2) {
        this.loading = true;
        singleProjectGenerate({
          projectId: sessionStorage.getItem("zt_jjkc_project_id"),
          beginTime: this.value1[0],
          endTime: this.value1[1],
        }).then((res) => {
          this.loading = false;
          if (res.code == "00000") {
            this.msgSuccess("生成完成");
            this.search();
          }
        });
      } else {
        this.$message.error("申报区间格式不正确");
      }
    },
    download(id) {
      downloadAuxiliaryAccount(id).then((res) => {
        if (res.code == "00000") {
          window.open(res.data);
        }
      });
    },
    search() {
      this.queryParam.proId = sessionStorage.getItem("zt_jjkc_project_id");
      this.loading = true;
      getProjectAccount(this.queryParam).then((res) => {
        console.log(res);
        this.loading = false;
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
  },
};
</script>
<style scoped>
.title_box {
  width: 100%;
  height: 40px;
  background-color: #e6f7ff;
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 20px 0;
}
.form_box .el-form-item {
  width: 46%;
}
.text {
  font-size: 14px;
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 20px;
}
.text::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
.gsadd {
  position: absolute;
  left: 17px;
  top: 20px;
  z-index: 9;
}
</style>
